export const en = {
    "alice-nominee": "Congratulations, your skill has been nominated for an Alice Award. More details on the [official page] of the award.",
    "alice-nominee-testing-finished": "Alice Award skill testing completed",
    "comment-skill-created": "Fill in all the fields on the settings page, test your dialog and submit it for moderation.",
    "deploy-complete": "Draft deployed",
    "deploy-rejected": "Deploy rejected",
    "deploy-requested": "Draft is being published",
    "dialog-created": "Dialog created",
    "dialog-deleted": "Dialog deleted",
    "dialog-not-published": "Dialog not published",
    "dialog-published": "Dialog published",
    "dialog-stopped": "Dialog stopped",
    "dialog-withdrawn": "Dialog withdrawn",
    "hint-in-dev": "To send a skill for moderation, fill in all the fields and settings for the account linking.",
    "draft": "Draft",
    "draft-in-development": "Draft in development",
    "in-development": "In development",
    "it-is-ok": "OK",
    "published-short": "Published",
    "published-long": "Published version",
    "ready": "Ready",
    "review-approved": "Draft approved by moderator",
    "review-cancelled": "Draft declined by moderator",
    "review-requested": "Draft on  moderation",
    "sh-analysis": "Analyzing results",
    "sh-approved": "Skill approved",
    "sh-in-dev": "Skill in development",
    "sh-meeting": "Negotiating meeting date",
    "sh-review-requested": "Reviewing skill description",
    "sh-testing": "Testing devices",
    "sh-waiting": "Waiting for testing",
    "skill-nominated": "Dialog nominated for the Alice Award",
    "skill-nomination-cancelled": "Dialog removed from the selection of nominees",
    "installable-app-status-withdraw": "Withdrawn",
    "installable-app-status-stopped": "Stopped",
    "installable-app-status-deleted": "Deleted",
    "installable-app-status-review-request": "Under Review",
    "installable-app-status-review-canceled": "Review Canceled",
    "installable-app-status-review-approved": "Review Approved",
    "installable-app-status-deploy-request": "Deployment Request",
    "installable-app-status-deploy-rejected": "Deployment Rejected",
    "installable-app-status-settings-review-approved": "Settings Approved",
    "installable-app-status-device-test-prepared": "Device Test Prepared",
    "installable-app-status-device-test-started": "Device Test Started",
    "installable-app-status-device-test-completed": "Device Test Completed",
    "installable-app-status-published": "Published",
    "installable-app-status-moderation-fail": "Moderation Failed",
    "scanning": "Scanning",
    "": ""
} as const;
export const ru = {
    "alice-nominee": "Поздравляем, ваш навык был номинирован на премию Алисы. Подробнее на [официальной странице премии]",
    "alice-nominee-testing-finished": "Тестирование навыка в рамках премии Алисы завершено",
    "comment-skill-created": "Заполните все поля на странице настроек, протестируйте свой диалог и отправьте его на модерацию.",
    "deploy-complete": "Черновик опубликован",
    "deploy-rejected": "Черновик не опубликован",
    "deploy-requested": "Черновик публикуется",
    "dialog-created": "Диалог создан",
    "dialog-deleted": "Диалог удалён",
    "dialog-not-published": "Диалог не опубликован",
    "dialog-published": "Диалог опубликован",
    "dialog-stopped": "Диалог остановлен",
    "dialog-withdrawn": "Диалог отозван",
    "hint-in-dev": "Чтобы отправить навык на модерацию, заполните все поля и настройки связки аккаунтов.",
    "draft": "Черновик",
    "draft-in-development": "Черновик в разработке",
    "in-development": "В разработке",
    "it-is-ok": "Понятно",
    "published-short": "Публикация",
    "published-long": "Опубликованная версия",
    "ready": "Готово",
    "review-approved": "Черновик одобрен модератором",
    "review-cancelled": "Черновик снят с модерации",
    "review-requested": "Черновик на модерации",
    "sh-analysis": "Анализ результатов",
    "sh-approved": "Навык одобрен",
    "sh-in-dev": "Навык в разработке",
    "sh-meeting": "Согласование даты тестирования",
    "sh-review-requested": "Проверка описания навыка",
    "sh-testing": "Тестирование устройств",
    "sh-waiting": "Ожидание тестирования",
    "skill-nominated": "Диалог номинирован на премию Алисы",
    "skill-nomination-cancelled": "Навык убран из подборки номинантов",
    "installable-app-status-withdraw": "отозван",
    "installable-app-status-stopped": "остановлен",
    "installable-app-status-deleted": "удален",
    "installable-app-status-review-request": "на модерации",
    "installable-app-status-review-canceled": "модерация не пройдена",
    "installable-app-status-review-approved": "модерация пройдена",
    "installable-app-status-deploy-request": "запрос на публикацию",
    "installable-app-status-deploy-rejected": "публикация запрещена",
    "installable-app-status-settings-review-approved": "настройки одобрены",
    "installable-app-status-device-test-prepared": "подготовлен тест устройства",
    "installable-app-status-device-test-started": "начат тест устройства",
    "installable-app-status-device-test-completed": "тест устройства завершен",
    "installable-app-status-published": "опубликован",
    "installable-app-status-moderation-fail": "модерация не пройдена",
    "scanning": "сканируется",
    "": ""
} as const;
